/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAscending = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m8.611 17.501 7.899-7.898v6.901c0 .551.452 1.004 1.004 1.004a.996.996 0 0 0 .997-.997v-9.32a.996.996 0 0 0-.997-.997h-9.32a.996.996 0 1 0 0 1.994h6.901l-7.898 7.899a1.003 1.003 0 0 0 0 1.414 1.003 1.003 0 0 0 1.414 0" /></svg>;
export default SvgAscending;